/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { t } from 'utils/translates';

class RulesOfRatingPopUp extends Component {
  render() {
    return (
      <div className="modal-dialog modal-gray" role="document">
        <div className="modal-content">
          <div className="modal-header text-center">
            <i className="fa fa-star-half-full modal-icon" />
            <h3 className="modal-title">{t('Как изменить рейтинг')}</h3>
            <p>{t('Правила начисления и списывания баллов')}</p>
          </div>
          <div className="modal-body">
            <h4>{t('Получение баллов')}</h4>
            <div className="table-responsive">
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>{t('Событие')}</th>
                    <th className="text-center">{t('Баллы')}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.userPointsTypes.map(item => {
                    if (item.points > 0) {
                      return (
                        <tr key={`userPointsTypesDesc${item.id}`}>
                          <td>
                            {item.title}
                            <span data-toggle="tooltip" title={item.title}>
                              {' '}
                              <i className="fa fa-question-circle" />
                            </span>
                          </td>
                          <th className="text-center text-success">
                            +{item.points}
                          </th>
                        </tr>
                      );
                    }
                    return null;
                  })}
                </tbody>
              </table>
            </div>
            <h4>{t('Списание баллов')}</h4>
            <div className="table-responsive">
              <table className="table table-striped table-hover m-b-0">
                <thead>
                  <tr>
                    <th>{t('Событие')}</th>
                    <th className="text-center">{t('Баллы')}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.userPointsTypes.map(item => {
                    if (item.points < 0) {
                      return (
                        <tr key={`userPointsTypesDesc${item.id}`}>
                          <td>
                            {item.title}
                            <span data-toggle="tooltip" title={item.title}>
                              {' '}
                              <i className="fa fa-question-circle" />
                            </span>
                          </td>
                          <th className="text-center text-danger">
                            {item.points}
                          </th>
                        </tr>
                      );
                    }
                    return null;
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-primary btn-block"
              data-dismiss="modal"
              type="button"
            >
              {t('Все понятно')}!
            </button>
          </div>
        </div>
      </div>
    );
  }
}

RulesOfRatingPopUp.propTypes = {
  userPointsTypes: PropTypes.arrayOf(PropTypes.shape).isRequired
};

const mapStateToProps = state => ({
  userPointsTypes: _.sortBy(
    getItemFromRefList(state, 'userPointsTypesNew'),
    'title'
  )
});

export default connect(mapStateToProps)(RulesOfRatingPopUp);



// WEBPACK FOOTER //
// ./src/components/Rating/StatusesDescTable/RulesOfRatingPopUp.js